export default __webpack_public_path__ + "b29d0ac.png";